import React from 'react';

import { Outlet } from 'react-router-dom';

import { Footer, Header } from '#/common/components';
import { AppContextProvider } from '#/context';

export default function Layout() {
    return (
        <AppContextProvider>
            <Header />
            <div className='overflow-hidden flex h-[calc(100dvh-118px)] bg-background'>
                <div className='flex-1 pt-4 px-14'>
                    <Outlet />
                </div>
            </div>
            <Footer />
        </AppContextProvider>
    );
}
